import { HealthDetailPage } from '@/components/shared/ReuseableHealthDeatil';
import { useGetMyMicrobiomeDetailV2 } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { MicrobiomeDetailResponse } from '@viome/viome-base/src/usecase/Health/Health.model';
import { JourneyEducationTypes } from '@utils/JourneyEducationTypes';
import { getRichnessAnimation } from '@utils/health/getAnimation';
import OralRichness from '@/assets/microbiome_oral.json';

export const OralRichnessPage = () => {
  const { data, isLoading, isError } = useGetMyMicrobiomeDetailV2('oral');

  if (isError) {
    return (
      <div className="dark bg-black h-full w-full flex justify-center items-center">
        <p className="typography-body text-primary">
          Failed to load data. Please try again.
        </p>
      </div>
    );
  }

  if (!data?.richness) {
    return null;
  }

  const { richness }: MicrobiomeDetailResponse = data;

  return (
    <HealthDetailPage
      data={{
        title: richness.title,
        about: richness.about,
        mainStat: `${String(richness.percentage)}`,
        subStat: richness.rank,
        rankColor: richness.rank_color,
        size: 'lg',
        overlayImg: '',
        richnessTrend: richness.trend,
        fallBackVdo: OralRichness,
        videoSrc: getRichnessAnimation('oral'),
        scoreId: richness.id,
      }}
      isMainStatPercentage
      journeyDeeperSectionInfo={JourneyEducationTypes.ORAL_MICROBIOME_DETAIL}
      isLoading={isLoading}
      screen="oral_richness"
    />
  );
};
